
export interface UserDocument {
  id: string;
  user_id: string;
  uploaded_by: string;
  file_name: string;
  file_path: string;
  file_size: number;
  file_type: string;
  document_type: string;
  description?: string;
  created_at: string;
  updated_at: string;
  uploader?: {
    name: string;
    nickname: string;
  };
}

export const DOCUMENT_TYPES = {
  attestation: "Attestation",
  carte_securite: "Carte de sécurité",
  permis: "Permis",
  formation: "Formation",
  autre: "Autre"
} as const;

export type DocumentType = keyof typeof DOCUMENT_TYPES;
